var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9403 8C13.3561 8 13.6933 8.32421 13.6933 8.72414V10.1849C14.3612 10.1724 15.1098 10.1724 15.9522 10.1724H19.9681C20.8104 10.1724 21.5591 10.1724 22.227 10.1849V8.72414C22.227 8.32421 22.5641 8 22.98 8C23.3958 8 23.733 8.32421 23.733 8.72414V10.2489C25.178 10.3602 26.1267 10.6333 26.8236 11.3036C27.5206 11.9738 27.8046 12.8862 27.9203 14.2759L28 15H8.92456H8V14.2759C8.11571 12.8862 8.3997 11.9738 9.09665 11.3036C9.79361 10.6333 10.7423 10.3602 12.1873 10.2489V8.72414C12.1873 8.32421 12.5244 8 12.9403 8Z",
    fill: "#00A991"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28 20.0001V18.0001C28 17.161 27.9968 15.6653 27.9839 15H8.00966C7.99675 15.6653 8.00001 17.161 8.00001 18.0001V20.0001C8.00001 23.7713 8.00001 25.6569 9.17159 26.8285C10.3432 28.0001 12.2288 28.0001 16 28.0001H20C23.7713 28.0001 25.6569 28.0001 26.8284 26.8285C28 25.6569 28 23.7713 28 20.0001Z",
    fill: "#00A991"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.876fb8fc2c8f781140e545ffba02cacb.svg";
export { ForwardRef as ReactComponent };